'use client'
import 'swiper/css'
import { clsx } from 'clsx'
import { Navigation } from 'swiper/modules'
import { Swiper, SwiperClass, SwiperProps } from 'swiper/react'

import { FC, useRef, useState } from 'react'

import { IChildren, IClassName } from '@/app/shared/interfaces/common.interface'
import { SliderArrowComponent } from '@/app/shared/ui/slider-arrow'

// interface
interface ISlider extends IChildren, Omit<SwiperProps, 'onSwiper'>, IClassName {
  arrow?: boolean
  classSwiper?: string
  onSwiper?: (e: SwiperClass) => void
}

// component
const SliderComponent: FC<Readonly<ISlider>> = ({
  children,
  className,
  arrow,
  classSwiper,
  onSwiper,
  ...props
}) => {
  const [isInit, setIsInit] = useState<boolean>(false)
  const prevEl = useRef<HTMLButtonElement | null>(null)
  const nextEL = useRef<HTMLButtonElement | null>(null)

  const modules = props.modules ?? []

  if (arrow) modules?.push(Navigation)

  const handleArrowInit = (swiper: SwiperClass) => {
    if (!arrow) return
    const navigation = swiper.params.navigation

    if (!navigation || !prevEl.current || !nextEL.current) return

    if (typeof navigation !== 'boolean') {
      navigation.prevEl = prevEl.current
      navigation.nextEl = nextEL.current
    }
  }

  return (
    <div
      className={clsx('flex flex-col-reverse transition-opacity', className, {
        'opacity-0': !isInit,
      })}
    >
      {arrow && (
        <div className={'mt-[30px] grid grid-cols-[auto_auto] justify-center gap-[20px]'}>
          <SliderArrowComponent button={'prev'} ref={prevEl} />
          <SliderArrowComponent button={'next'} ref={nextEL} />
        </div>
      )}
      <div>
        <Swiper
          {...props}
          modules={[...(props?.modules ?? []), ...modules]}
          className={classSwiper}
          onBeforeInit={arrow ? handleArrowInit : props.onBeforeInit}
          onSwiper={(e) => {
            setIsInit(true)
            if (onSwiper) onSwiper(e)
          }}
        >
          {children}
        </Swiper>
      </div>
    </div>
  )
}

export default SliderComponent
